import axios from 'axios';

const useLocal = false; // Set to true to use local server

const standardAPI = axios.create({
  baseURL: useLocal ? 'http://127.0.0.1:8001' : 'https://standard.trysixth.com'
});

export default standardAPI;
